"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalFormComponent = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var index_1 = require("../../i18n/index");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var input_state_group_1 = require("../input/input.state.group");
var mithril_component_1 = require("../mithril.component");
var modal_service_1 = require("../modal/modal.service");
var notification_service_1 = require("../notification.toast/notification.service");
var spinner_1 = require("../spinner/spinner");
var ModalFormComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ModalFormComponent, _super);
    function ModalFormComponent(ctx) {
        var _this = _super.call(this) || this;
        _this.loading = false;
        _this.form = new input_state_group_1.IkeInputStateGroup();
        _this.displaySubmitButton = true;
        _this.displayCancelButton = true;
        _this.ctx = ctx;
        return _this;
    }
    ModalFormComponent.prototype.onCreate = function () {
        var _this = this;
        if (this.validate != null) {
            this.autorun(function () { var _a; return (_a = _this.validate) === null || _a === void 0 ? void 0 : _a.call(_this); });
        }
    };
    ModalFormComponent.prototype.open = function () {
        var _this = this;
        if (modal_service_1.ModalService.isOpen) {
            return;
        }
        this.reset();
        modal_service_1.ModalService.open({
            title: this.ctx.title,
            content: function () { return _this.view(); },
            actions: function () { return _this.viewActions(); },
            onSubmit: function () { return _this.wrapSubmit(); },
            canClose: function () { return _this.canClose(); }
        }).then(function () { return _this.reset(); });
    };
    ModalFormComponent.prototype.close = function () {
        this.reset();
        modal_service_1.ModalService.close(false);
    };
    ModalFormComponent.prototype.reset = function () {
        this.form.reset();
        this.loading = false;
    };
    ModalFormComponent.prototype.addState = function (input) {
        this.form.add(input);
    };
    ModalFormComponent.prototype.setLoading = function (loading) {
        this.loading = loading;
    };
    ModalFormComponent.prototype.canClose = function () {
        return !this.loading;
    };
    ModalFormComponent.prototype.viewSubmitButton = function () {
        var confirmContent = typeof this.ctx.confirm === 'function' ? this.ctx.confirm() : this.ctx.confirm;
        var submitChildren = this.loading ? spinner_1.Spinner.view() : (0, index_1.Translate)(confirmContent);
        return (0, mithril_1.m)('button', { className: 'mdl-button mdl-button--accent', disabled: !this.form.canSubmit || this.loading, type: 'submit' }, submitChildren);
    };
    ModalFormComponent.prototype.viewCancelButton = function () {
        var _this = this;
        var cancelContent = typeof this.ctx.cancel === 'function' ? this.ctx.cancel() : this.ctx.cancel;
        var cancelText = cancelContent ? (0, index_1.Translate)(cancelContent) : (0, index_1.Translate)(index_1.T.CANCEL);
        return (0, mithril_1.m)('button', { className: 'mdl-button', onclick: function () { return _this.close(); }, disabled: this.loading, type: 'button' }, cancelText);
    };
    ModalFormComponent.prototype.viewActions = function () {
        var actionButtons = [];
        if (this.displayCancelButton) {
            actionButtons.push(this.viewCancelButton());
        }
        if (this.displaySubmitButton) {
            actionButtons.push(this.viewSubmitButton());
        }
        return mithril_1.m.fragment({}, actionButtons);
    };
    ModalFormComponent.prototype.wrapSubmit = function () {
        var _this = this;
        if (!this.form.canSubmit) {
            services_1.Logger.error('Attempted to submit invalid form...');
            return false;
        }
        this.setLoading(true);
        return Promise.resolve()
            .then(function () { return _this.submit != null ? _this.submit() : null; })
            .then(function () { return !services_1.Services.License.hasNoLicense && notification_service_1.NotificationService.success(_this.ctx.success); })
            .then(function () { return _this.close(); })
            .catch(function (e) {
            services_1.Logger.error(e);
            notification_service_1.NotificationService.error({ key: index_1.T.ERROR_GENERAL });
            _this.setLoading(false);
            if (_this.failToChange != null) {
                _this.failToChange(e);
            }
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], ModalFormComponent.prototype, "loading", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ModalFormComponent.prototype, "displaySubmitButton", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], ModalFormComponent.prototype, "displayCancelButton", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalFormComponent.prototype, "open", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalFormComponent.prototype, "close", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalFormComponent.prototype, "reset", null);
    tslib_1.__decorate([
        mobx_1.action
    ], ModalFormComponent.prototype, "setLoading", null);
    return ModalFormComponent;
}(mithril_component_1.IMithrilStateComponent));
exports.ModalFormComponent = ModalFormComponent;
//# sourceMappingURL=modal.form.component.js.map